"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeImage = void 0;
var TypeImage;

(function (TypeImage) {
  /**
   * 현재 웹뷰의 이미지 피커를 설정해요
   * @optional maxImageCount    허용할 최대 이미지 갯수
   * @optional canImageBeEdited 이미지 편집 기능 사용 여부
   */
  TypeImage["ReqImageConfigure"] = "REQ.IMAGE.CONFIGURE";
  /**
   * 이미지 피커를 열어요 (iOS Only)
   */

  TypeImage["ReqImagePick"] = "REQ.IMAGE.PICK";
  /**
   * 이미지 피커의 응답 (iOS Only)
   * @required images 선택된 이미지 목록
   */

  TypeImage["ResImagePick"] = "RES.IMAGE.PICK";
})(TypeImage = exports.TypeImage || (exports.TypeImage = {}));